import _get from 'lodash/get';
import _isString from 'lodash/isString';

export const getErrorResponse = (error) => {
  const responseData = _get(error, 'response.data', error.toString());
  // Support both JSON and plain text error responses
  const responseMessage = responseData?.message ?? responseData;
  return _isString(responseMessage) ? responseMessage : '';
};
